import { useQuery } from '@tanstack/react-query'
import { useTenant } from '@/hooks/use-tenant'
import { tenantQuery } from '@/lib/supabase-tenant'
import type { Notification } from '@/types/tenant'

export function useNotifications() {
  const { schemaName, isReady } = useTenant()

  return useQuery<Notification[]>({
    queryKey: ['notifications', schemaName],
    queryFn: async () => {
      const { data, error } = await tenantQuery(schemaName!)
        .from('notifications')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(50)

      if (error) throw error
      return data as Notification[]
    },
    enabled: isReady,
    refetchInterval: 30000, // Poll every 30 seconds
  })
}
